/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";

import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import {
  Grid,
  Typography,
  Button,
  Divider,
  Chip,
  IconButton,
  Tooltip,
  ButtonGroup,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Backdrop,
  Paper,
  Tabs,
  Tab,
} from "@material-ui/core";

import CheckCircleOutlined from "@material-ui/icons/CheckCircleOutlined";
import HighlightOff from "@material-ui/icons/HighlightOff";
import Add from "@material-ui/icons/Add";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Refresh from "@material-ui/icons/Refresh";
import AutoRenew from "@material-ui/icons/Autorenew";
import AutorenewTwoToneIcon from "@material-ui/icons/AutorenewTwoTone";
import EditOutlined from "@material-ui/icons/EditOutlined";
import SyncAlt from "@material-ui/icons/SyncAlt";
import ExitToAppOutlinedIcon from "@material-ui/icons/ExitToAppOutlined";
import QueryBuilderIcon from "@material-ui/icons/QueryBuilder";
import DynamicFeedIcon from "@material-ui/icons/DynamicFeed";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import NotInterestedIcon from "@material-ui/icons/NotInterested";
import UpdateIcon from "@material-ui/icons/Update";

import MaterialTable, { MTableToolbar } from "material-table";
import table_icons from "../tableIcons";

import Actions from "../../fluid/Actions/ActionFactory";
import ErrorMessageAlert from "../Utilities/ErrorMessageAlert";
import { DeleteConfirmationDialog } from "./../Utilities/DeleteConfirmationDialog";
import AddDataDevice from "../CreateIC/AddDataDevice";
import Scheduler from "../Scheduler/Scheduler";

import DataTransfer from './components/DataTransfer'
import TrainTrigger from './components/TrainTrigger'

import IUChip from './components/InformationUnit/IUChip'
import OperationChip from './components/Operation/OperationChip'
import InformationChannel from './components/InformationChannel/InformationChannel'

import SecureWrapper from "../Security/SecureWrapper";
import { allowedByOpop } from "../Security/SecureCheck";

const styles = (theme) => ({
  "@keyframes spin": {
    from: { transform: "rotate(0deg)" },
    to: { transform: "rotate(360deg)" },
  },
  "@keyframes slide": {
    from: { left: "0px" },
    tp: { right: "30px" },
  },
  in_progress: {
    color: "#039be5",
    textAlign: "center",
    animation: "$spin 2s infinite linear",
  },
  in_progress_dt: {
    color: "#039be5",
    textAlign: "center",
    animation: "$slide 2s infinite linear",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
});

const blue_theme = createMuiTheme({
  palette: {
    primary: {
      main: "#2296f3",
    },
    // primary: {
    //     main: "#FF6600",
    //     contrastText: "#FFFFFFFF"
    // },
    secondary: {
      main: "#dc004e",
    },
  },
});

class ICList extends Component {
  

  state = {
    loading: false,
    data: [],
    deletingIC: null,
    currentICName: null,
    deletingIU: null,
    anchorRef: null,
    error: false,
    error_message: null,
    deleteICAlertDialogOpen: false,
    deleteIUAlertDialogOpen: false,
    icDataTransferErrorDialogOpen: false,
    icDataTransferErrorInfo: {},
    iuDataTransferErrorDialogOpen: false,
    iuDataTransferErrorInfo: {},
    trainICErrorDialogOpen: false,
    trainsICErrorInfo: {},
    retrainAllErrorOpen: false,
    retrainAllErrorInfo: {},
    retrainAllInProgress: false,
    statusErrorDialogOpen: false,
    statusErrorInfo: {},
    addingIU: false,
    icDetailPanelTabNo: 0,
    iuDetailPanelTabNo: 0,
    selectedIC : null,
    isComponentLoaded: false,
    closePanel: false
  };

  componentDidMount() {
    
      this.getData();
      // if (this.state.selectedIC !== null ) {
        
      //   this.tableRef.current.onToggleDetailPanel([[this.tableRef.current.dataManager.sortedData.findIndex(item => item.name === this.state.selectedIC)]], this.tableRef.current.props.detailPanel)
      // }
    
    
  }

  componentDidUpdate (prevProps, prevState) {
        
      // if(this.state.selectedIC !== null ){
      //   this.tableRef.current.onToggleDetailPanel([[this.tableRef.current.dataManager.sortedData.findIndex(item => item.name === this.state.selectedIC)]], this.tableRef.current.props.detailPanel)
    
      // }
        console.log("Selected IC : ", this.state.selectedIC)
       if(prevState.selectedIC !== null){
          if (this.state.selectedIC !== null && this.state.selectedIC === prevState.selectedIC ) {
            this.tableRef.current.onToggleDetailPanel([[this.tableRef.current.dataManager.sortedData.findIndex(item => item.name === this.state.selectedIC)]], this.tableRef.current.props.detailPanel)
          
          } else if(this.state.selectedIC !== null && this.state.selectedIC !== prevState.selectedIC) {
            this.tableRef.current.onToggleDetailPanel([[this.tableRef.current.dataManager.sortedData.findIndex(item => item.name === this.state.selectedIC)]], this.tableRef.current.props.detailPanel)
          
          } else{
            this.setState({ selectedIC:  null})
          }
        }
    
  }

  tableRef = React.createRef()

  handleICDetailPanelTabNoChange = (event, selectedTabNo) => {
    this.setState({
      icDetailPanelTabNo: selectedTabNo,
    });
  };

  handleIUDetailPanelTabNoChange = (event, selectedTabNo) => {
    this.setState({
      iuDetailPanelTabNo: selectedTabNo,
    });
  };

  getData = () => {
    this.setState({ ...this.state, loading: true }, () => {
      Actions("http_request", {
        url: "/sainapse/information_channel",
        method: "get",
        data: {},
      })
        .then((res) => {
          this.setState({
            ...this.state,
            loading: false,
            data: res.data.result,
          });
        })
        .catch((err) => {
          this.setState({
            ...this.state,
            loading: false,
            error: true,
            error_message: err,
          });
        });
    });
  };

  closeError = () => {
    this.setState({ ...this.state, error: false, error_message: null });
  };

  //handle delete IC button click
  deleteInfoChannel = (ic_name) => {
    this.setState({
      ...this.state,
      deletingIC: ic_name,
      deleteICAlertDialogOpen: true,
    });
  };

  //handle cancel on delete ic confirmation dialog.
  cancelDeletingIC = () => {
    this.setState({
      deleteICAlertDialogOpen: false,
      deletingIC: "",
    });
  };

  //handle deletet click on delete ic confirmation dialog.
  confirmDeletingIC = () => {
    //have current ic deleting indication in actions.
    this.setState({
      deleteICAlertDialogOpen: false,
    });
    Actions("http_request", {
      url: "/sainapse/information_channel/" + this.state.deletingIC,
      method: "delete",
      data: {},
    })
      .then((res) => {
        this.setState({
          data: this.state.data.filter(
            (ic) => ic.name !== this.state.deletingIC
          ),
          deletingIC: "",
          selectedIC : null
        });
      })
      .catch((err) => {
        this.setState({ ...this.state, deletingIC: "" });
        this.setState({ error: true, error_message: err });
        // this.getData();
      });
  };

  //handle delete IU button click
  deleteInfoUnit = (icName, iu_name) => {
    this.setState({
      ...this.state,
      currentICName: icName,
      deletingIU: iu_name,
      deleteIUAlertDialogOpen: true,
    });
  };

  //handle cancel on delete iu confirmation dialog.
  cancelDeletingIU = () => {
    this.setState({
      deleteIUAlertDialogOpen: false,
      deletingIU: "",
    });
  };

  //handle deletet click on delete ic confirmation dialog.
  confirmDeletingIU = () => {
    //have current ic deleting indication in actions.
    this.setState({
      deleteIUAlertDialogOpen: false,
    });
    Actions("http_request", {
      url:
        "/sainapse/information_channel/" +
        this.state.currentICName +
        "/information_unit/" +
        this.state.deletingIU,
      method: "delete",
      data: {},
    })
      .then((res) => {
        this.setState({
          data: this.state.data.map((ic) => {
            if (ic.name === this.state.currentICName) {
              return {
                ...ic,
                information_units: ic.information_units.filter(
                  (iu) => iu.name !== this.state.deletingIU
                ),
              };
            }
            return ic;
          }),
          deletingIU: "",
        });
      })
      .catch((err) => {
        this.setState({ ...this.state, deletingIU: "" });
        this.setState({ error: true, error_message: err });
      });
  };

  transferData = (transfer_object, entity) => {
    Actions("http_request", {
      url: "/sainapse/train/data",
      method: "post",
      data: [transfer_object]
    })
    .then((res) => {
      this.getData();
      // console.log("Data Transfer: ", res.data.result);
    })
    .catch((err) => {
      if (entity === "ic") {
        this.setState({
          icDataTransferErrorDialogOpen: true,
          icDataTransferErrorInfo: err,
        });
      } else if (entity === "iu") {
        this.setState({
          iuDataTransferErrorDialogOpen: true,
          iuDataTransferErrorInfo: err,
        });
      }
    });
  }

  dataTransferIC = (ic_data) => {
    this.setState({ loading: true }, () => {
      let ic_name = ic_data.name;
      //let iu_names = ic_data.information_units.map((iu) => iu.name);
      let iu_names = [];

      ic_data.information_units.map((iu) => {
        if (iu.config_type === "Trainable") {
          iu_names.push(iu.name);
        }
      });
      // console.log("IU Names: ", iu_names);

      Actions("http_request", {
        url: "/sainapse/train/data",
        method: "post",
        data: [
          {
            ic_name: ic_name,
            iu_names: iu_names,
          },
        ],
        // params : {
        //     ic_name : ic_name,
        //     iu_names : iu_names.join(',')
        // }
      })
        .then((res) => {
          this.getData();
          // console.log("Data Transfer: ", res.data.result);
        })
        .catch((err) => {
          this.setState({
            loading: false,
            icDataTransferErrorDialogOpen: true,
            icDataTransferErrorInfo: err,
          });
        });
    });
  };

  hanldeICDataTransferErrorDialogClose = () => {
    this.setState({
      icDataTransferErrorInfo: {},
      icDataTransferErrorDialogOpen: false,
    });
  };

  datatransferIU = (icName, iu_data) => {
    this.setState({ loading: true }, () => {
      let ic_name = icName;
      let iu_name = iu_data.name;

      Actions("http_request", {
        url: "/sainapse/train/data",
        method: "post",
        data: [
          {
            ic_name: ic_name,
            iu_names: [iu_name],
          },
        ],
        // params : {
        //     ic_name : ic_name,
        //     iu_names : iu_name
        // }
      })
        .then((res) => {
          this.getData();
          // console.log("Data Transfer: ", res.data.result);
        })
        .catch((err) => {
          this.setState({
            loading: false,
            iuDataTransferErrorDialogOpen: true,
            iuDataTransferErrorInfo: err,
          });
        });
    });
  };

  hanldeIUDataTransferErrorDialogClose = () => {
    this.setState({
      iuDataTransferErrorInfo: {},
      iuDataTransferErrorDialogOpen: false,
    });
  };

  getTrainableOperations = (ic_data) => {
    let operations = [];

    let ic_operations = ic_data.operations;
    ic_operations.map((operation) => {
      let op_index = ic_data.operationAnnotations.findIndex(
        (op) => op.type === operation
      );
      if (ic_data.operationAnnotations[op_index].is_trainable=== true) {
        operations.push(operation);
      }
    });

    return operations;
  };

  trainIC = (ic_data) => {
    this.setState({ loading: true }, () => {
      Actions("http_request", {
        url: "/sainapse/train",
        method: "post",
        data: [
          {
            ic_name: ic_data.name,
            operations: this.getTrainableOperations(ic_data),
          },
        ],
      })
        .then((res) => {
          this.getData();
        })
        .catch((err) => {
          this.setState({
            loading: false,
            trainICErrorDialogOpen: true,
            trainsICErrorInfo: err,
          });
        });
    });
  };

  retrainAllICs = () => {
    let payloadForRetrainAll = [];

    this.setState({ retrainAllInProgress: true });

    this.state.data.forEach((icData) => {
      if (
        icData.data_transfer_status === null ||
        icData.training_status === "InProgress" ||
        icData.data_transfer_status === "Aborted" ||
        icData.data_transfer_status === "InProgress"
      ) {
        //if any of those above conditions met do not add that ic to list of ic's that needs to be retrained.
      } else {
        payloadForRetrainAll.push({
          ic_name: icData.name,
          operations: this.getTrainableOperations(icData),
        });
      }
    });

    Actions("http_request", {
      url: "/sainapse/train",
      method: "post",
      data: payloadForRetrainAll,
    })
      .then((res) => {
        this.setState(
          {
            retrainAllInProgress: false,
          },
          () => this.getData()
        );
      })
      .catch((err) => {
        this.setState({
          retrainAllInProgress: false,
          retrainAllErrorOpen: true,
          retrainAllErrorInfo: err,
        });
      });
  };

  hanldeTrainICErrorDialogClose = () => {
    this.setState({
      trainsICErrorInfo: {},
      trainICErrorDialogOpen: false,
    });
  };

  hanldeReTrainAllICsErrorDialogClose = () => {
    this.setState({
      retrainAllErrorInfo: {},
      retrainAllErrorOpen: false,
    });
  };

  hanldeICTrainStatusErrorDialogClose = () => {
    this.setState({
      statusErrorInfo: {},
      statusErrorDialogOpen: false,
    });
  };

  getTrainingStatus = (ic_data) => {
    Actions("http_request", {
      url: "/sainapse/train/information_channel/status",
      method: "get",
      data: {},
      params: {
        ic_name: ic_data.name,
      },
    })
      .then((res) => {
        this.getData();
      })
      .catch((err) => {
        this.setState({
          statusErrorInfo: err,
          statusErrorDialogOpen: true,
        });
      });
  };

  renderTrainingRefreshIcon = (ic_data) => {
    if (ic_data.training_status === "InProgress") {
      return (
        <Tooltip title="Refresh training status" arrow>
          <IconButton
            size="small"
            style={{ color: "#039be5" }}
            onClick={() => this.getTrainingStatus(ic_data)}
          >
            <Refresh size="small" />
          </IconButton>
        </Tooltip>
      );
    }
  };

  isICTrainEanbled = (ic_data, retrainAllStatus) => {
    //if retrainAll is in progress we can't enable individual ic train option
    //if training is in progress we can't enable train button .
    if (retrainAllStatus === true || ic_data.training_status === "InProgress") {
      return false;
    }

    let trainbleIUs = ic_data.information_units.filter(
      (iu) => iu.config_type === "Trainable"
    );

    if (trainbleIUs.length === 0) {
      return false;
    }

    let dataTransferCompletedForAllTrainableIUs = true;

    for (let i = 0; i < trainbleIUs.length; i++) {
      if (!(trainbleIUs[i].data_transfer_status === "Completed")) {
        dataTransferCompletedForAllTrainableIUs = false;
        break;
      }
    }

    return dataTransferCompletedForAllTrainableIUs;
  };

  isICDataTransferEnabled = (ic_data, retrainAllStatus) => {
    //if retrainAll is in progress we can't enable individual ic data transfer option
    //if training is in progress we can't enable data transfer button .
    if (retrainAllStatus === true || ic_data.training_status === "InProgress") {
      return false;
    }

    let trainbleIUs = ic_data.information_units.filter(
      (iu) => iu.config_type === "Trainable"
    );

    if (trainbleIUs.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  getDisableICStatus= (name) => {
    
    return !allowedByOpop({
      operation : "/sainapse/information_channel/{name}",
      method : "DELETE",
      operands : [
        {
          attrName: "name",
          value : name
    }]
    })
  };

  getDisableIUStatus= (icName, iuName) => {
    
    return !allowedByOpop({
      operation : "/sainapse/information_channel/{ic_name}/information_unit/{name}",
      method : "DELETE",
      operands : [
        {
          attrName: "ic_name",
          value : icName
        },
        {
          attrName: "name",
          value : iuName
    }]
    })
  };

  //render IC actions column
  renderICActions = (row_data) => {
    if (
      row_data.name !== this.state.deletingIC ||
      this.state.deleteICAlertDialogOpen
    ) {
      return (
        <div style={{ display: "flex", flexDirection: "row" }}>
          {/* 
          REF: Bug ID: 2794
          <Tooltip title="Edit" arrow>
            <IconButton size="small" style={{ marginRight: "0px" }}>
              <EditOutlined fontSize="small" />
            </IconButton>
          </Tooltip> */}
          <Tooltip title="Delete" arrow>
            <IconButton
              id = {"delete-ic-" + row_data.name} 
              size="small"
              style={{ color: !this.getDisableICStatus(row_data.name) ? "#f44336": "rgb(0,0,0,0.3)", marginRight: "0px" }}
              onClick={() => this.deleteInfoChannel(row_data.name)}
              disabled = {this.getDisableICStatus(row_data.name)}
            >
              <DeleteOutline fontSize="small" />
            </IconButton>
          </Tooltip>
          {/* <Tooltip title="Initiate Data Transfer" arrow>
            <IconButton
              disabled={
                !this.isICDataTransferEnabled(
                  row_data,
                  this.state.retrainAllInProgress
                )
              }
              size="small"
              style={{
                color: this.isICDataTransferEnabled(
                  row_data,
                  this.state.retrainAllInProgress
                )
                  ? "#039be5"
                  : null,
              }}
              onClick={() => this.dataTransferIC(row_data)}
            >
              <ExitToAppOutlinedIcon fontSize="small" />
            </IconButton>
          </Tooltip> */}
          {/* <DataTransfer ic_data = {row_data} entity = "ic" entity_name = {row_data.name} transfer_data = {(transfer_object, entity, entity_name) => this.transferData(transfer_object, entity)}/> */}
          {/* <Tooltip title="Re(Train)" arrow>
            <IconButton
              size="small"
              style={{
                color: this.isICTrainEanbled(
                  row_data,
                  this.state.retrainAllInProgress
                )
                  ? "#4caf50"
                  : null,
                display: this.isICTrainEanbled(
                  row_data,
                  this.state.retrainAllInProgress
                )
                  ? "block"
                  : "none",
              }}
              onClick={() => this.trainIC(row_data)}
            >
              <AutorenewTwoToneIcon fontSize="small" />
            </IconButton>
          </Tooltip> */}
          {/* <TrainTrigger ic_data = {row_data} get_data = {this.getData}/> */}
          {/* {this.renderTrainingRefreshIcon(row_data)} */}
        </div>
      );
    } else {
      return <Typography variant="overline">Deleting...</Typography>;
    }
  };

  //render IU actions column
  renderIUActions = (icData, row_data) => {
    let icName = icData.name;
    if (
      row_data.name !== this.state.deletingIU ||
      this.state.deleteIUAlertDialogOpen
    ) {
      return (
        <div style={{ display: "flex", flexDirection: "row" }}>
          <Tooltip title="Edit" arrow>
            <IconButton size="small" style={{ marginRight: "0px" }}>
              <EditOutlined fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete" arrow>
            <IconButton
              size="small"
              style={{ color: !this.getDisableIUStatus(icName, row_data.name) ? "#f44336": "rgb(0,0,0,0.3)", marginRight: "0px" }}
              onClick={() => this.deleteInfoUnit(icName, row_data.name)}
              disabled = {this.getDisableIUStatus(icName, row_data.name)} 
            >
              <DeleteOutline fontSize="small" />
            </IconButton>
          </Tooltip>
          {row_data.config_type === "Trainable" ? (
            // <Tooltip title="Initiate Data Transfer">
            //   <IconButton
            //     disabled={
            //       this.state.retrainAllInProgress !== true &&
            //       row_data.access_details !== null &&
            //       row_data.access_parameters !== null &&
            //       row_data.fields_in_scope !== null &&
            //       row_data.iu_world_view !== null &&
            //       icData.training_status !== "InProgress" &&
            //       icData.data_transfer_status !== "InProgress"
            //         ? false
            //         : true
            //     }
            //     size="small"
            //     style={{
            //       color:
            //         this.state.retrainAllInProgress !== true &&
            //         row_data.access_details !== null &&
            //         row_data.access_parameters !== null &&
            //         row_data.fields_in_scope !== null &&
            //         row_data.iu_world_view !== null &&
            //         icData.training_status !== "InProgress" &&
            //         icData.data_transfer_status !== "InProgress"
            //           ? "#039be5"
            //           : null,
            //     }}
            //   >
            //     <ExitToAppOutlinedIcon
            //       fontSize="small"
            //       onClick={() => this.datatransferIU(icName, row_data)}
            //     />
            //   </IconButton>
            // </Tooltip>
            <DataTransfer ic_data = {icData} entity = "iu" entity_name = {row_data.name} transfer_data = {(transfer_object, entity, entity_name) => this.transferData(transfer_object, entity)}/>
          ) : null}
        </div>
      );
    } else {
      return <Typography variant="overline">Deleting...</Typography>;
    }
  };

  renderICDataTransferStatus = (row_data) => {
    const { classes } = this.props;

    let status_list = [];
    if (row_data.information_units.length > 0) {
      status_list = row_data.information_units.map((iu) => {
        return (
          <IUChip key = {iu.name} iu = {iu}/>
        )
        // let transfer_status = iu.data_transfer_status;
        // if (transfer_status === "Queued") {
        //   return (
        //     <Tooltip title={iu.name + " || Queued"}>
        //       <QueryBuilderIcon fontSize="small" style={{ color: "#FF6600" }} />
        //     </Tooltip>
        //   );
        // } else if (transfer_status === "InProgress") {
        //   return (
        //     <Tooltip title={iu.name + " || In Progress"}>
        //       <ArrowRightAltIcon
        //         fontSize="small"
        //         className={classes.in_progress_dt}
        //       />
        //     </Tooltip>
        //   );
        // } else if (transfer_status === "Aborted") {
        //   return (
        //     <Tooltip title={iu.name + " || Aborted"}>
        //       <ErrorOutlineIcon fontSize="small" style={{ color: "#f44336" }} />
        //     </Tooltip>
        //   );
        // } else if (transfer_status === "Completed") {
        //   return (
        //     <Tooltip title={iu.name + " || Completed"}>
        //       <CheckCircleOutlined
        //         fontSize="small"
        //         style={{ color: "#4caf50" }}
        //       />
        //     </Tooltip>
        //   );
        // }
      });

      return status_list;
    } else {
      return (
        <Typography variant = 'caption' color = 'textSecondary'>No IUs registered</Typography>
        // <Tooltip title={"No IUs Available"}>
        //   <NotInterestedIcon fontSize="small" style={{ color: "#f44336" }} />
        // </Tooltip>
      );
    }
  };

  renderIUDataTransferStatus = (data_transfer_status_object) => {
    const { classes } = this.props;

    let transfer_status = data_transfer_status_object.status;
    let iu_name = data_transfer_status_object.iu_name;
    if (transfer_status === "Queued") {
      return (
        <Tooltip title={iu_name + " || Queued"}>
          <QueryBuilderIcon fontSize="small" style={{ color: "#FF6600" }} />
        </Tooltip>
      );
    } else if (transfer_status === "InProgress") {
      return (
        <Tooltip title={iu_name + " || In Progress"}>
          <ArrowRightAltIcon
            fontSize="small"
            className={classes.in_progress_dt}
          />
        </Tooltip>
      );
    } else if (transfer_status === "Aborted") {
      return (
        <Tooltip title={iu_name + " || Aborted"}>
          <ErrorOutlineIcon fontSize="small" style={{ color: "#f44336" }} />
        </Tooltip>
      );
    } else if (transfer_status === "Completed") {
      return (
        <Tooltip title={iu_name + " || Completed"}>
          <CheckCircleOutlined fontSize="small" style={{ color: "#4caf50" }} />
        </Tooltip>
      );
    }
  };

  renderICTrainingStatus = (row_data) => {
    const { classes } = this.props;

    let status;

    status = row_data.training_status_object.map((ops) => {
      if (ops.status === "Queued") {
        return (
          <Tooltip title={ops.operation + " || Queued"}>
            <QueryBuilderIcon
              fontSize="small"
              style={{ color: "#FF6600", textAlign: "center" }}
            />
          </Tooltip>
        );
      } else if (ops.status === "InProgress") {
        return (
          <Tooltip title={ops.operation + " || In Progress"}>
            <AutorenewTwoToneIcon
              className={classes.in_progress}
              fontSize="small"
            />
          </Tooltip>
        );
      } else if (ops.status === "Aborted") {
        return (
          <Tooltip title={ops.operation + " || Aborted"}>
            <ErrorOutlineIcon
              fontSize="small"
              style={{ color: "#f44336", textAlign: "center" }}
            />
          </Tooltip>
        );
      } else if (ops.status === "Completed") {
        return (
          <Tooltip title={ops.operation + " || Completed"}>
            <CheckCircleOutlined
              fontSize="small"
              style={{ color: "#4caf50", textAlign: "center" }}
            />
          </Tooltip>
        );
      }
    });

    return status;
  };

  renderICDetailPanelTrainingStatus = (trainingStatus) => {
    const { classes } = this.props;

    if (trainingStatus.status === "Queued") {
      return (
        <Tooltip title={trainingStatus.operation + " || Queued"}>
          <QueryBuilderIcon
            fontSize="small"
            style={{ color: "#FF6600", textAlign: "center" }}
          />
        </Tooltip>
      );
    } else if (trainingStatus.status === "InProgress") {
      return (
        <Tooltip title={trainingStatus.operation + " || In Progress"}>
          <AutorenewTwoToneIcon
            className={classes.in_progress}
            fontSize="small"
          />
        </Tooltip>
      );
    } else if (trainingStatus.status === "Aborted") {
      return (
        <Tooltip title={trainingStatus.operation + " || Aborted"}>
          <ErrorOutlineIcon
            fontSize="small"
            style={{ color: "#f44336", textAlign: "center" }}
          />
        </Tooltip>
      );
    } else if (trainingStatus.status === "Completed") {
      return (
        <Tooltip title={trainingStatus.operation + " || Completed"}>
          <CheckCircleOutlined
            fontSize="small"
            style={{ color: "#4caf50", textAlign: "center" }}
          />
        </Tooltip>
      );
    }
  };

  isIUAddEnabled = (row_data) => {
    try {
      //if operations are not configured for given ic , do not enable add IU button
      return row_data.world_view.configs.length > 0;
    } catch (err) {
      return false;
    }
  };

  renderDevices = (row_data) => {
    return (
      <MaterialTable
        title="Information Units"
        icons={table_icons}
        columns={[
          { title: "Name", field: "name" },
          {
            title: "Key",
            field: "key",
            render: (rowData) => {
              return (
                <Chip
                  size="small"
                  style={{ backgroundColor: "#2296f3", color: "#FFFFFF" }}
                  label={rowData.key}
                />
              );
            },
          },
          // {title : 'Type', field : 'type', render : rowData => {
          //     return  (
          //         <Chip size = 'small' style = {{backgroundColor : '#2296f3', color : '#FFFFFF' }} label = {rowData.type}/>
          //     )
          // }},
          {
            title: "Access Details",
            field: "access_details",
            render: (rowData) => {
              if (rowData.access_details === null) {
                return (
                  <HighlightOff fontSize="small" style={{ color: "#f44336" }} />
                );
              } else {
                return (
                  <CheckCircleOutlined
                    fontSize="small"
                    style={{ color: "#4caf50" }}
                  />
                );
              }
            },
          },
          {
            title: "Adaptor Inputs",
            field: "access_parameters",
            render: (rowData) => {
              if (rowData.access_parameters === null) {
                return (
                  <HighlightOff fontSize="small" style={{ color: "#f44336" }} />
                );
              } else {
                return (
                  <CheckCircleOutlined
                    fontSize="small"
                    style={{ color: "#4caf50" }}
                  />
                );
              }
            },
          },
          {
            title: "Fields In Scope",
            field: "fields_in_scope",
            render: (rowData) => {
              if (rowData.fields_in_scope === null) {
                return (
                  <HighlightOff fontSize="small" style={{ color: "#f44336" }} />
                );
              } else {
                return (
                  <CheckCircleOutlined
                    fontSize="small"
                    style={{ color: "#4caf50" }}
                  />
                );
              }
            },
          },
          {
            title: "World View Map",
            field: "iu_world_view",
            render: (rowData) => {
              if (rowData.iu_world_view === null) {
                return (
                  <HighlightOff fontSize="small" style={{ color: "#f44336" }} />
                );
              } else {
                return (
                  <CheckCircleOutlined
                    fontSize="small"
                    style={{ color: "#4caf50" }}
                  />
                );
              }
            },
          },
          {
            title: "Last Data Transfer Date",
            field: "last_data_transfer_date",
            type: "datetime",
          },
          {
            title: "Actions",
            field: "name",
            sorting: false,
            render: (rowData) => {
              //passing ic name that will be used for iu crud operations
              return this.renderIUActions(row_data, rowData);
            },
          },
        ]}
        data={row_data.information_units || []}
        options={{
          search: true,
          cellStyle: {
            height: "20px",
            paddingTop: 0,
            paddingBottom: 0,
          },
          toolbarButtonAlignment: "right",
          paging: false,
          headerStyle: {
            // paddingTop: '3px',
            // paddingBottom: '3px',
            // margin: 0,
            // textAlign: "center",
            // backgroundColor: "#F0F0F0",
            zIndex : 0,
            backgroundColor : "#FAFAFA"
          },
          maxBodyHeight: "78vh",
          detailPanelType: "single",
          draggable: false,
        }}
        detailPanel={(rowData) => {
          //set currently selected ic name that will be used to handle iu crud operations.
          // this.setState({currentICName: rowData.name})

          return (
            <ThemeProvider theme={blue_theme}>
              <div style = {{backgroundColor : '#F0F0F0'}}>
                <Paper square>
                  <Tabs
                    value={this.state.iuDetailPanelTabNo}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    onChange={this.handleIUDetailPanelTabNoChange}
                    aria-label="iU-detail-panel-tabs"
                  >
                    <Tab
                      style={{
                        paddingLeft: "20px",
                        paddingRight: "20px",
                      }}
                      disableRipple={true}
                      wrapped={false}
                      label="Data Transfer Status"
                    />
                  </Tabs>
                </Paper>
                <div style = {{padding : '10px'}}>
                  {this.renderIUDetailPanel(rowData)}
                </div>
              </div>
            </ThemeProvider>
          );
        }}
        components={{
          Toolbar: (props) => (
            <Fragment>
              {/* <MTableToolbar {...props} />
              <Divider /> */}
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row-reverse",
                  // height: "5vh",
                  alignContent: "flex-end",
                  paddingRight: "16px",
                }}
              >
                <ThemeProvider theme={blue_theme}>
                <SecureWrapper
                      access_object = {{
                        operation : "/sainapse/information_channel/{ic_name}/information_unit",
                        method : "POST",
                        operands : [
                          {
                            attrName: "ic_name",
                            value : row_data.name
                      }]
                      }}
                    >
                  <Tooltip
                    title="Create New IU"
                    disabled={!this.isIUAddEnabled(row_data)}
                    onClick={(event) => {
                      event.preventDefault();
                      this.handleCreateIUDialogOpen(row_data);
                    }}
                  >
                    <IconButton color="primary">
                      <Add />
                    </IconButton>
                  </Tooltip>
                  </SecureWrapper>
                </ThemeProvider>
              </div>
              <Divider />
            </Fragment>
          ),
        }}
      />
    );
  };

  renderICTrainingStatusTable = (train_status_list = []) => {
    return (
      <MaterialTable
        title="Information Units"
        icons={table_icons}
        columns={[
          {
            title: "ID",
            field: "id",
          },
          {
            title: "Start Time",
            field: "start_time",
            type: "datetime",
          },
          {
            title: "End Time",
            field: "end_time",
            type: "datetime",
          },
          {
            title: "Operation",
            field: "operation",
            render: (trainStatusObjct) => {
              return (
                <Chip
                  size="small"
                  style={{
                    backgroundColor: "#2296f3",
                    color: "#FFFFFF",
                    margin: "5px",
                  }}
                  label={trainStatusObjct.operation}
                />
              );
            },
          },
          {
            title: "Status",
            field: "status",
            render: (trainStatusObjct) => {
              return this.renderICDetailPanelTrainingStatus(trainStatusObjct);
            },
          },
          {
            title: "Additional Info",
            field: "message",
          },
        ]}
        data={train_status_list || []}
        options={{
          search: false,
          toolbar: false,
          showTitle: false,
          paging: false,
          detailPanelType: "single",
          headerStyle : {
            zIndex : 0,
            backgroundColor : "#FAFAFA"
          }
        }}
      />
    );
  };

  renderIUDataTransferStatusTable = (data_transfer_status_list = []) => {
    return (
      <MaterialTable
        title="Information Units"
        icons={table_icons}
        columns={[
          {
            title: "ID",
            field: "id",
          },
          {
            title: "Start Time",
            field: "start_time",
            type: "datetime",
          },
          {
            title: "End Time",
            field: "end_time",
            type: "datetime",
          },

          {
            title: "Status",
            field: "status",
            render: (dataTransferStatusObjct) => {
              return this.renderIUDataTransferStatus(dataTransferStatusObjct);
            },
          },
          {
            title: "Additional Info",
            field: "message",
          },
        ]}
        data={data_transfer_status_list || []}
        options={{
          search: false,
          toolbar: false,
          showTitle: false,
          paging: false,
          detailPanelType: "single",
          headerStyle : {
            zIndex : 0,
            backgroundColor : "#FAFAFA"
          }
        }}
      />
    );
  };

  renderICDetailPanel = (row_data) => {
    switch (this.state.icDetailPanelTabNo) {
      case 0:
        return this.renderDevices(row_data);
      case 1:
        return this.renderICTrainingStatusTable(
          row_data.training_status_object
        );
      default:
        return this.renderDevices(row_data);
    }
  };

  renderIUDetailPanel = (row_data) => {
    return this.renderIUDataTransferStatusTable(
      row_data.data_transfer_status_object
    );
  };

  goToCreateIc = () => {
    this.props.history.push({
      pathname: "/create-ic",
    });
  };

  handleCreateIUDialogOpen = (row_data) => {
    const { classes } = this.props;
    // console.log("row_data_in create iu");
    // console.log(row_data);
    this.setState({
      ...this.state,
      addingIU: true,
      currentICName: row_data.name,
    });
  };

  renderCreateIUDialog = () => {
    const { classes } = this.props;
    if (this.state.addingIU) {
      return (
        <Backdrop
          className={classes.backdrop}
          style={{ width: "100vw", height: "100vh" }}
          open={this.state.addingIU}
        >
          <AddDataDevice
            ic_name={this.state.currentICName}
            close={this.handleCreateIUDialogClose}
            iu_name={null}
            edit={false}
          />
        </Backdrop>
      );
    }
  };

  handleCreateIUDialogClose = () => {
    this.setState({ addingIU: false }, () => this.getData());
  };

  renderError = () => {
    if (this.state.error === true) {
      return (
        <ThemeProvider theme={blue_theme}>
          <ErrorMessageAlert
            open={this.state.error}
            handleClose={this.closeError}
            errorInfo={this.state.error_message}
          />
        </ThemeProvider>
      );
    }
  };

  renderICDeleteConfirmDialog = () => {
    return (
      <DeleteConfirmationDialog
        open={this.state.deleteICAlertDialogOpen}
        name={this.state.deletingIC}
        type={"IC"}
        confirmDeleteHandler={this.confirmDeletingIC}
        cancelDeleteHandler={this.cancelDeletingIC}
      ></DeleteConfirmationDialog>
    );
  };

  renderIUDeleteConfirmDialog = () => {
    return (
      <DeleteConfirmationDialog
        open={this.state.deleteIUAlertDialogOpen}
        name={this.state.deletingIU}
        type={"IU"}
        confirmDeleteHandler={this.confirmDeletingIU}
        cancelDeleteHandler={this.cancelDeletingIU}
      ></DeleteConfirmationDialog>
    );
  };

  renderICDataTransferErrorDialog = () => {
    return (
      <ErrorMessageAlert
        open={this.state.icDataTransferErrorDialogOpen}
        handleClose={this.hanldeICDataTransferErrorDialogClose}
        errorInfo={this.state.icDataTransferErrorInfo}
      ></ErrorMessageAlert>
    );
  };

  renderIUDataTransferErrorDialog = () => {
    return (
      <ErrorMessageAlert
        open={this.state.iuDataTransferErrorDialogOpen}
        handleClose={this.hanldeIUDataTransferErrorDialogClose}
        errorInfo={this.state.iuDataTransferErrorInfo}
      ></ErrorMessageAlert>
    );
  };

  renderTrainICErrorDialog = () => {
    return (
      <ErrorMessageAlert
        open={this.state.trainICErrorDialogOpen}
        handleClose={this.hanldeTrainICErrorDialogClose}
        errorInfo={this.state.trainsICErrorInfo}
      ></ErrorMessageAlert>
    );
  };

  renderICTrainStausErrorDialog = () => {
    return (
      <ErrorMessageAlert
        open={this.state.statusErrorDialogOpen}
        handleClose={this.hanldeICTrainStatusErrorDialogClose}
        errorInfo={this.state.statusErrorInfo}
      ></ErrorMessageAlert>
    );
  };

  renderReTrainAllICsErrorDialog = () => {
    return (
      <ErrorMessageAlert
        open={this.state.retrainAllErrorOpen}
        handleClose={this.hanldeReTrainAllICsErrorDialogClose}
        errorInfo={this.state.retrainAllErrorInfo}
      ></ErrorMessageAlert>
    );
  };

  handleErrorClose = () => {
    this.setState({ errorOpen: false, errorInfo: "" });
  };

  updateErrorFromScheduler = (err) => {
    this.setState({
      ...this.state,
      error: true,
      error_message: err,
    });
  }

  getDetailPanelContent = (rowData) => {
    // let that = this;
    if (this.state.selectedIC !== rowData.name ) {
      this.setState({...this.state, selectedIC : rowData.name}, () => {
        
      })
    } else {
     
    }

    return (
      <div style = {{width : '100%', maxHeight : '70vh', overflow : 'scroll'}}>
        <InformationChannel ic = {rowData} refresh = {this.getData} handleCreateIUDialogOpen = {() => this.handleCreateIUDialogOpen(rowData)}
          updateErrorFromScheduler = { (err) => this.updateErrorFromScheduler(err)}
        />
      </div>
    );
    
  }

  render() {
    return (
      <Fragment>
        <ThemeProvider theme = {blue_theme}>
        <div id = "ic-table">
        <SecureWrapper
                      access_object = {{
                        operation : "/sainapse/information_channel",
                        method : "GET",
                        operands : []
                      }}
                      shouldRenderErrorMessage = {true}
                      errorMessage = "User does not have sufficient privileges"
                      textVariant = "subtitle2"
                    >
        <MaterialTable
          tableRef={this.tableRef}
          style={{ width: "100%" }}
          title="Information Channels"
          icons={table_icons}
          columns={[
            { title: "Name", field: "name" },
            {
              title: "Created On",
              field: "created_date",
              type: "datetime",
              defaultSort: "desc",
            },
            {
              title: "Updated On",
              field: "updated_date",
              type: "datetime",
            },
            { title: "Type", field: "type" },
            {
              title: "Information Units",
              field: "data_transfer_status",
              disableClick : true,
              sorting: false,
              render: (rowData) => {
                return this.renderICDataTransferStatus(rowData);
              },
            },
            {
              title: "Operations",
              field: "operations",
              render: (rowData) => (
                <div style={{ width: "15vw" }}>
                  {rowData.operations.map((operation) => {
                    return (
                      <OperationChip
                        ic = {rowData}
                        op = {operation}
                      />
                      // <Chip
                      //   size="small"
                      //   style={{
                      //     backgroundColor: "#2296f3",
                      //     color: "#FFFFFF",
                      //     margin: "5px",
                      //   }}
                      //   label={item.annotation}
                      // />
                    );
                  })}
                </div>
              ),
            },
            {
              title: "World View",
              field: "world_view",
              sorting: false,
              cellStyle : {
                textAlign : 'center'
              },
              render: (rowData) => {
                if (
                  rowData.world_view === null ||
                  rowData.world_view.length === 0
                ) {
                  return (
                    <HighlightOff
                      fontSize="small"
                      style={{ color: "#f44336" }}
                    />
                  );
                } else {
                  return (
                    <CheckCircleOutlined
                      fontSize="small"
                      style={{ color: "#4caf50" }}
                    />
                  );
                }
              },
            },
            // {
            //   title: "Training Status",
            //   field: "training_status",
            //   sorting: false,
            //   render: (rowData) => {
            //     return this.renderICTrainingStatus(rowData);
            //   },
            // },
            {
              title: "Actions",
              field: "name",
              sorting: false,
              disableClick : true,
              render: (rowData) => {
                return this.renderICActions(rowData);
              },
            },
          ]}
          data={this.state.data || []}
          isLoading={this.state.loading || this.state.retrainAllInProgress}
          loadingType="linear"
          options={{
            search: true,
            rowStyle: {

            },
            cellStyle: {
              height: "20px",
              paddingTop: 0,
              paddingBottom: 0
            },
            toolbarButtonAlignment: "right",
            paging : false,
            headerStyle: {
              // height: "7vh",
              padding: 0,
              margin: 0,
              textAlign: "center",
              backgroundColor: "#F0F0F0",
              zIndex : 10,
              // lineHeight: "1.25",
            },
            maxBodyHeight: "78vh",
            detailPanelType: "single",
            draggable: false,
          }}
          onRowClick={(event, rowData, togglePanel) => {
            if (this.state.selectedIC !== rowData.name) {
              this.setState({...this.state, selectedIC : rowData.name}, () => {
              })
            } else {
              this.setState({...this.state, selectedIC : null}, () => togglePanel())
            }
          }}
          detailPanel={(rowData) => {
            // set currently selected ic name that will be used to handle iu crud operations.
            // this.setState({currentICName: rowData.name})
            return this.getDetailPanelContent(rowData)
          }}
          components={{
            Toolbar: (props) => (
              <Fragment>
                <MTableToolbar {...props} />
                <Divider />
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row-reverse",
                    // height: "5vh",
                    alignContent: "flex-end",
                  }}
                >
                  <ThemeProvider theme={blue_theme}>
                  <SecureWrapper
                      access_object = {{
                        operation : "/sainapse/information_channel",
                        method : "GET",
                        operands : []
                      }}
                    >
                    <Tooltip title="Refresh" onClick={this.getData}>
                      <IconButton color="primary">
                        <Refresh />
                      </IconButton>
                    </Tooltip>
                    </SecureWrapper>
                    <SecureWrapper
                      access_object = {{
                        operation : "/sainapse/information_channel",
                        method : "POST",
                        operands : []
                      }}
                    >
                      <Tooltip title="Create IC">
                        <IconButton id = "create-ic-button" color="primary" onClick={this.goToCreateIc}>
                          <Add />
                        </IconButton>
                      </Tooltip>
                    </SecureWrapper>
                    {/* <Tooltip
                      title="Re(Train) All"
                      arrow
                      onClick={this.retrainAllICs}
                    >
                      <IconButton
                        disabled={this.state.retrainAllInProgress}
                        color="primary"
                      >
                        <AutorenewTwoToneIcon fontSize="small" />
                      </IconButton>
                    </Tooltip> */}
                  </ThemeProvider>
                </div>
                <Divider />
              </Fragment>
            ),
          }}
        />
        </SecureWrapper>
        </div>
        {this.renderError()}
        {this.renderICDataTransferErrorDialog()}
        {this.renderIUDataTransferErrorDialog()}
        {this.renderTrainICErrorDialog()}
        {this.renderICTrainStausErrorDialog()}
        {this.renderReTrainAllICsErrorDialog()}
        {this.renderICDeleteConfirmDialog()}
        {this.renderIUDeleteConfirmDialog()}
        {this.renderCreateIUDialog()}
        </ThemeProvider>
      </Fragment>
    );
  }
}

export default withRouter(withStyles(styles)(ICList));
